import {
  IPassTransaction,
  PASS_PAYMENT_METHOD,
  PASS_TRANSACTION_STATUS,
} from "types/transfer/pass.interface";
import { createMockListPage } from "./listingMocks";
import {
  DEMO_ACADEMY_NORTH_ID,
  DEMO_ACADEMY_SOUTH_ID,
  DEMO_GROUP_U13B,
  DEMO_GROUP_U15A,
  DEMO_GROUP_U17,
  matchesAcademyIds,
  matchesDateRange,
  matchesGroupIds,
  matchesStatusIn,
} from "./mockFilterHelpers";
import { DEMO_ACADEMY_ID } from "./mockPlayers";
import { demoApi } from "./demoLocale";

export const mockPassTransactions: IPassTransaction[] = [
  {
    TransactionId: "00000000-0000-0000-0000-000000000b01",
    Number: "KAR/2026/001",
    ValitTo: new Date("2026-08-31"),
    Player: { PlayerId: "00000000-0000-0000-0000-000000000101", Name: "Jan Kowalski" },
    Period: { StartAt: new Date("2026-07-01"), EndAt: new Date("2026-07-31") },
    Pass: { PassId: "00000000-0000-0000-0000-000000000c01", Name: "Karnet miesięczny" },
    Price: { Tax: 23, Netto: 243.9, Gross: 300 },
    Status: PASS_TRANSACTION_STATUS["Zapłacony"],
    PaymentMethod: PASS_PAYMENT_METHOD["Przelew"],
    IsBoughtAsCompany: false,
    Academy: { AcademyId: DEMO_ACADEMY_ID, Name: "Klub piłkarski" },
    Groups: [{ GroupId: DEMO_GROUP_U15A, Name: "Pierwsza drużyna" }],
  },
  {
    TransactionId: "00000000-0000-0000-0000-000000000b02",
    Number: "KAR/2026/002",
    ValitTo: new Date("2026-08-31"),
    Player: { PlayerId: "00000000-0000-0000-0000-000000000102", Name: "Adam Nowak" },
    Period: { StartAt: new Date("2026-07-01"), EndAt: new Date("2026-07-31") },
    Pass: { PassId: "00000000-0000-0000-0000-000000000c02", Name: "Karnet miesięczny" },
    Price: { Tax: 23, Netto: 243.9, Gross: 300 },
    Status: PASS_TRANSACTION_STATUS["Oczekuje na zapłatę"],
    PaymentMethod: PASS_PAYMENT_METHOD["Gotówka"],
    IsBoughtAsCompany: true,
    Academy: { AcademyId: DEMO_ACADEMY_ID, Name: "Klub piłkarski" },
    Groups: [{ GroupId: DEMO_GROUP_U13B, Name: "Rezerwy" }],
  },
  {
    TransactionId: "00000000-0000-0000-0000-000000000b03",
    Number: "KAR/2026/003",
    ValitTo: new Date("2026-08-31"),
    Player: { PlayerId: "00000000-0000-0000-0000-000000000103", Name: "Piotr Wiśniewski" },
    Period: { StartAt: new Date("2026-06-01"), EndAt: new Date("2026-06-30") },
    Pass: { PassId: "00000000-0000-0000-0000-000000000c03", Name: "Karnet wakacyjny" },
    Price: { Tax: 23, Netto: 121.95, Gross: 150 },
    Status: PASS_TRANSACTION_STATUS["Wakacje"],
    PaymentMethod: PASS_PAYMENT_METHOD["Przelew"],
    IsBoughtAsCompany: false,
    Academy: { AcademyId: DEMO_ACADEMY_ID, Name: "Klub piłkarski" },
    Groups: [{ GroupId: DEMO_GROUP_U17, Name: "U17" }],
  },
  {
    TransactionId: "00000000-0000-0000-0000-000000000b04",
    Number: "KAR/2026/004",
    ValitTo: new Date("2026-08-31"),
    Player: { PlayerId: "00000000-0000-0000-0000-000000000201", Name: "Kacper Malinowski" },
    Period: { StartAt: new Date("2026-07-01"), EndAt: new Date("2026-07-31") },
    Pass: { PassId: "00000000-0000-0000-0000-000000000c04", Name: "Karnet miesięczny" },
    Price: { Tax: 23, Netto: 243.9, Gross: 300 },
    Status: PASS_TRANSACTION_STATUS["Niezapłacony"],
    PaymentMethod: PASS_PAYMENT_METHOD["Przelew"],
    IsBoughtAsCompany: false,
    Academy: { AcademyId: DEMO_ACADEMY_NORTH_ID, Name: "Oddział Akademii" },
    Groups: [{ GroupId: DEMO_GROUP_U15A, Name: "Pierwsza drużyna" }],
  },
  {
    TransactionId: "00000000-0000-0000-0000-000000000b05",
    Number: "KAR/2026/005",
    ValitTo: new Date("2026-08-31"),
    Player: { PlayerId: "00000000-0000-0000-0000-000000000303", Name: "Bartosz Krawczyk" },
    Period: { StartAt: new Date("2026-08-01"), EndAt: new Date("2026-08-31") },
    Pass: { PassId: "00000000-0000-0000-0000-000000000c05", Name: "Karnet miesięczny" },
    Price: { Tax: 23, Netto: 162.6, Gross: 200 },
    Status: PASS_TRANSACTION_STATUS["Zapłacony"],
    PaymentMethod: PASS_PAYMENT_METHOD["Gotówka"],
    IsBoughtAsCompany: false,
    Academy: { AcademyId: DEMO_ACADEMY_SOUTH_ID, Name: "Oddział Akademii - Zachodni" },
    Groups: [{ GroupId: "00000000-0000-0000-0000-000000001801", Name: "Młodzik 2013" }],
  },
];

const passFilters = [
  (transaction: IPassTransaction, pageInfo: any) =>
    matchesAcademyIds(transaction.Academy?.AcademyId, pageInfo),
  (transaction: IPassTransaction, pageInfo: any) =>
    matchesStatusIn(transaction.Status, pageInfo.TransactionStatuses),
  (transaction: IPassTransaction, pageInfo: any) =>
    matchesGroupIds(
      transaction.Groups?.map((group) => group.GroupId),
      pageInfo
    ),
  (transaction: IPassTransaction, pageInfo: any) =>
    matchesDateRange(transaction.Period?.StartAt, pageInfo.FromDate, pageInfo.ToDate),
];

export const getMockPassTransactionsPage = demoApi((pageInfo: any) =>
  createMockListPage(mockPassTransactions, pageInfo, {
    search: (transaction, search) =>
      transaction.Number.toLowerCase().includes(search) ||
      transaction.Player.Name.toLowerCase().includes(search),
    filters: passFilters,
  }));

export const getMockSinglePassTransaction = demoApi(
  async (passId?: string, _playerName?: string) => {
    const items = mockPassTransactions.filter((transaction) => transaction.Pass?.PassId === passId);
    return {
      Items: items,
      TotalCount: items.length,
    };
  }
);

export const getMockPassTransactionDetail = demoApi(
  async (_passId?: string, transactionId?: string) => {
    const tx =
      mockPassTransactions.find((transaction) => transaction.TransactionId === transactionId) ??
      mockPassTransactions.find((transaction) => transaction.Pass?.PassId === _passId) ??
      mockPassTransactions[0];

    const nameParts = (tx.Player?.Name ?? "").trim().split(/\s+/);
    const firstName = nameParts[0] || null;
    const lastName = nameParts.slice(1).join(" ") || null;

    return {
      Invoice: {
        FirstName: firstName,
        LastName: lastName,
        Street: "Piłkarska",
        BuildingNumber: "1",
        FlatNumber: null,
        PostCode: "00-001",
        City: "Warszawa",
        Region: null,
        PhoneNumber: null,
        NIP: tx.IsBoughtAsCompany ? "5250000000" : null,
        CompanyName: tx.IsBoughtAsCompany ? "Demo Sp. z o.o." : null,
        Country: 0,
      },
      InvoiceUrl: "",
      TransactionHistories: [
        {
          TransactionHistoryId: `${tx.TransactionId}-h1`,
          CreatedAt: tx.Period?.StartAt ?? new Date(),
          Data: `Status: ${tx.Status}`,
        },
      ],
    };
  }
);